import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeftIcon } from "@heroicons/react/20/solid";

export default function NavBanner() {
  const navigate = useNavigate();

  const onClick = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <div className="relative isolate flex items-center overflow-hidden bg-white">
      <div className="flex flex-1">
        <button
          type="button"
          className="p-3 focus-visible:outline-offset-[-4px]"
          onClick={onClick}
        >
          <span className="sr-only">Go Back</span>
          <ArrowLeftIcon aria-hidden="true" className="h-5 w-5 text-gray-900" />
        </button>
      </div>
    </div>
  );
}
